module.exports = __webpack_public_path__ + "img/edge_hebergements_lit.7521c426.svg";